/**
 * Миноговые — 3 видов.
 *
 * ⚠️ ПОМЕТКИ «── ГДЕ ВОДИТСЯ ──» ПЕРЕЕХАЛИ СЮДА ВМЕСТЕ С РЫБОЙ. Вторая сотня
 * набиралась по краям света, и в прежнем файле виды стояли блоками: Иберия,
 * Балканы, Восточная Азия. Разрез по семействам эти блоки разнёс бы по
 * девятнадцати файлам, и знание о том, откуда вид, пропало бы вовсе — в коде
 * его больше нигде нет. Поэтому пометка идёт за своей рыбой.
 */
export const МИНОГОВЫЕ = [
    // ── Наши воды ──
    {
        id: 'river_lamprey',
        семейство: 'миноговые',
        latin: 'Lampetra fluviatilis',
        повадка: 'мелочь',
        minKg: 0.02,
        maxKg: 0.15,
        typicalKg: 0.06,
        typicalLengthM: 0.3,
        depthM: 3,
        depthBandM: 2,
        сложение: 'змеевидное',
        пасть: 'хрящевая',
        редкость: 'массовая',
        когда: 'ночная',
        вода: { мин: 1, опт: 8, макс: 18 },
        течение: 'сильное',
        держится: ['камни', 'ил', 'перекат'],
        стая: 'большая_стая',
        нерест: { с: 5, по: 6 },
        чем: [],
    },
    {
        id: 'ukrainian_lamprey',
        семейство: 'миноговые',
        latin: 'Eudontomyzon mariae',
        повадка: 'мелочь',
        minKg: 0.005,
        maxKg: 0.04,
        typicalKg: 0.015,
        typicalLengthM: 0.18,
        depthM: 2,
        depthBandM: 1.5,
        сложение: 'змеевидное',
        пасть: 'хрящевая',
        редкость: 'нечастая',
        когда: 'ночная',
        вода: { мин: 2, опт: 12, макс: 20 },
        течение: 'слабое',
        держится: ['ил', 'твёрдое_дно', 'камни'],
        стая: 'малая_стая',
        нерест: { с: 4, по: 5 },
        чем: [],
        краснокнижная: true,
    },
    // ── Западная и Северная Европа ──
    {
        id: 'brook_lamprey',
        семейство: 'миноговые',
        latin: 'Lampetra planeri',
        повадка: 'мелочь',
        minKg: 0.002,
        maxKg: 0.01,
        typicalKg: 0.005,
        typicalLengthM: 0.14,
        depthM: 0.5,
        depthBandM: 0.4,
        сложение: 'змеевидное',
        пасть: 'хрящевая',
        редкость: 'нечастая',
        когда: 'ночная',
        вода: { мин: 1, опт: 10, макс: 18 },
        течение: 'слабое',
        держится: ['ил', 'камни', 'перекат'],
        стая: 'малая_стая',
        нерест: { с: 4, по: 5 },
        чем: [],
        краснокнижная: true,
    },
];
//# sourceMappingURL=petromyzontids.js.map